/* -------------------------------------------------------------------------- */
/*                        Tag styles                        */
/* -------------------------------------------------------------------------- */

@import './bq-tag.variables';

:host {
  @apply relative inline-block;
}

:host([hidden]) {
  @apply hidden;
}

.bq-tag {
  @apply box-border inline-flex select-none flex-row items-center justify-center bg-[--bq-tag--background-color];
  @apply gap-[--bq-tag--medium-gap] font-medium leading-regular text-primary p-b-[--bq-tag--medium-padding-y] p-i-[--bq-tag--medium-padding-x];
  @apply rounded-[--bq-tag--border-radius] border-[length:--bq-tag--border-width] border-[color:--bq-tag--border-color];
  @apply transition-colors duration-300 ease-in-out;

  border-style: var(--bq-tag--border-style);
}

/* ---------------------------------- Size ---------------------------------- */

.bq-tag__xsmall,
.bq-tag__small {
  @apply gap-[--bq-tag--small-gap] p-b-[--bq-tag--small-padding-y] p-i-[--bq-tag--small-padding-x];

  /* Apply predefined border radius only if the border property have NO VALUE */
  &:not(.has-border) {
    @apply rounded-[--bq-tag--small-border-radius];
  }
}

/* --------------------------------- Action --------------------------------- */

.bq-tag__default.is-clickable {
  @apply cursor-pointer;
  // Focus
  @apply focus-visible:focus;
  // Hover
  @apply hover:enabled:bg-[color-mix(in_srgb,_var(--bq-tag--background-color),_var(--bq-hover)_20%)];
  // Active/Selected
  @apply [&.active]:text-alt [&.active]:[--bq-tag--background-color:--bq-ui--brand];
  // Disabled
  @apply disabled:cursor-not-allowed disabled:border-none disabled:opacity-60;
}

/* ------------------------------ Color styles ------------------------------ */

.bq-tag__error {
  &.bq-tag__filled {
    @apply bg-ui-danger text-alt;
  }

  &.bq-tag__outline {
    @apply bg-ui-danger-alt text-danger [--bq-tag--border-color:--bq-stroke--danger];
  }
}

.bq-tag__gray {
  &.bq-tag__filled {
    @apply bg-ui-tertiary text-alt;
  }

  &.bq-tag__outline {
    @apply bg-ui-primary text-primary [--bq-tag--border-color:--bq-stroke--tertiary];
  }
}

.bq-tag__info {
  &.bq-tag__filled {
    @apply bg-ui-brand text-alt;
  }

  &.bq-tag__outline {
    @apply bg-ui-brand-alt text-brand [--bq-tag--border-color:--bq-stroke--brand];
  }
}

.bq-tag__success {
  &.bq-tag__filled {
    @apply bg-ui-success text-alt;
  }

  &.bq-tag__outline {
    @apply bg-ui-success-alt text-success [--bq-tag--border-color:--bq-tag--border-success];
  }
}

.bq-tag__warning {
  &.bq-tag__filled {
    @apply bg-ui-warning text-alt;
  }

  &.bq-tag__outline {
    @apply border-warning bg-ui-warning-alt text-warning;
  }
}

/* --------------- Apply the right size to the bq-icon prefix --------------- */

.bq-tag__prefix ::slotted(bq-icon) {
  --bq-icon--size: var(--bq-tag--icon-prefix-size) !important;
}
